import {matchMediaQuery} from "@21torr/dune/media-query.js";

export const onSmall = matchMediaQuery("screen and (max-width: 767px)");
export const onLarge = matchMediaQuery("screen and (min-width: 1024px)");
export const onXLarge = matchMediaQuery("screen and (min-width: 1200px)");
